/**
 * LINKS DE CONVITE DA ESCOLA — caso E das regras de 06/10 (repo instituicoes-ensino).
 *
 * "Quem entra por link de convite já entra aprovado. Gerar o link é a aprovação do educador, que
 * pode desativar o link a qualquer hora." Só aparece para educador ativo da escola, dentro da
 * moderação dela.
 */
import { useCallback, useEffect, useState } from "react";
import { Convite, convitesDaInstituicao, criarConvite, desativarConvite } from "./api";
import { PapelInstituicao } from "./modelo";

export function linkDoConvite(codigo: string): string {
  return `${window.location.origin}/convite/${codigo}`;
}

export default function ConvitesDaEscola({ instituicaoId, educadorUid }: { instituicaoId: string; educadorUid: string }) {
  const [convites, setConvites] = useState<Convite[]>([]);
  const [ocupado, setOcupado] = useState(false);
  const [aviso, setAviso] = useState<string | null>(null);

  const recarregar = useCallback(async () => {
    setConvites(await convitesDaInstituicao(instituicaoId));
  }, [instituicaoId]);

  useEffect(() => {
    void recarregar();
  }, [recarregar]);

  async function criar(papel: PapelInstituicao) {
    setOcupado(true);
    const r = await criarConvite(instituicaoId, papel, educadorUid);
    setOcupado(false);
    setAviso(r.ok ? "Link criado. Quem abrir entra já aprovado." : r.erro || "Não deu. Tente de novo.");
    await recarregar();
  }

  async function desativar(codigo: string) {
    setOcupado(true);
    const r = await desativarConvite(codigo);
    setOcupado(false);
    setAviso(r.ok ? "Link desativado. Ele não aceita mais ninguém." : r.erro || "Não deu. Tente de novo.");
    await recarregar();
  }

  const ativos = convites.filter((c) => c.ativo);

  return (
    <div className="inst-convites" data-testid="convites">
      <p className="ajuda">
        Links de convite: quem abre o link entra já aprovado, sem passar pela fila.
      </p>
      <span className="inst-acoes">
        <button type="button" className="botao-secundario" disabled={ocupado} onClick={() => criar("aluno")}>
          Criar link para estudantes
        </button>
        <button type="button" className="botao-secundario" disabled={ocupado} onClick={() => criar("educador")}>
          Criar link para educadores
        </button>
      </span>
      {aviso && <p className="inst-aviso inst-aviso-ok" role="status">{aviso}</p>}
      {ativos.length > 0 && (
        <ul className="inst-lista">
          {ativos.map((c) => (
            <li key={c.codigo} className="inst-item" data-codigo={c.codigo}>
              <div>
                <strong>{c.papel === "educador" ? "Para educadores" : "Para estudantes"}</strong>
                <span className="inst-detalhe inst-link">{linkDoConvite(c.codigo)}</span>
              </div>
              <span className="inst-acoes">
                <button
                  type="button"
                  className="botao-secundario"
                  onClick={() => {
                    navigator.clipboard?.writeText(linkDoConvite(c.codigo)).then(
                      () => setAviso("Link copiado."),
                      () => setAviso("Não deu para copiar: selecione o link e copie.")
                    );
                  }}
                >
                  Copiar
                </button>
                <button type="button" className="botao-sair" disabled={ocupado} onClick={() => desativar(c.codigo)}>
                  Desativar
                </button>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
